import { render, staticRenderFns } from "./CuadroAportaciones.vue?vue&type=template&id=fccfbe78&scoped=true"
import script from "./CuadroAportaciones.vue?vue&type=script&lang=js"
export * from "./CuadroAportaciones.vue?vue&type=script&lang=js"
import style0 from "./CuadroAportaciones.vue?vue&type=style&index=0&id=fccfbe78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccfbe78",
  null
  
)

export default component.exports